import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "./axios";
import { z } from "zod";

const badgeSchema = z.object({
    title: z.string(),
    description: z.string(),
    type: z.enum(["Player", "Team"]),
    rarity: z.enum(["Common", "Rare", "Epic", "Legendary"]),
    players: z.array(z.string()),
});

const badgesResponseSchema = z.array(badgeSchema);

export type Badge = z.infer<typeof badgeSchema>;

function normalizeMatchIds(matchIds?: number | number[]): number[] {
    if (typeof matchIds === "number") {
        return [matchIds];
    }
    if (Array.isArray(matchIds)) {
        return matchIds;
    }
    return [];
}

export const fetchMatchBadges = async (matchIds?: number | number[], teamId?: number): Promise<Badge[]> => {
    const matchIdsArray = normalizeMatchIds(matchIds);

    try {
        const response = await axiosInstance.post("/badges/match", { matchIds: matchIdsArray, teamId });
        return badgesResponseSchema.parse(response.data);
    } catch (error) {
        const idsText = matchIdsArray.length > 0 ? ` for IDs ${matchIdsArray.join(", ")}` : "";
        throw new Error(`Failed to fetch match badges${idsText}: ${error}`);
    }
};

export const matchBadgesQueryOptions = (matchIds?: number | number[], teamId?: number) =>
    queryOptions({
        queryKey: ["match-badges", matchIds, teamId],
        queryFn: () => fetchMatchBadges(matchIds, teamId),
        staleTime: 5 * 60 * 1000,
    });
